module.exports = __webpack_public_path__ + "static/media/Plastics7.927cf2ea.jpg";